import page from './List.vue';

export default page;



// WEBPACK FOOTER //
// ./src/components/page/blog/list/index.ts